import _clone from 'lodash-es/clone.js';
import _toPath from 'lodash-es/toPath.js';
import _get from 'lodash-es/get.js';

var deps = {
  clone: _clone,
  toPath: _toPath,
  get: _get,
};

export default deps;
